import React from 'react';
import ReactDOM from 'react-dom';
import jwt_decode from 'jwt-decode';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import PrivateRoute from './components/common/PrivateRoute';
import { logoutUser, setCurrentUser } from './actions/authActions';
import setAuthToken from './utils/setAuthToken';
import store from './store';
import { GOOGLE_ANALYTICS_KEY, GOOGLE_ADWORDS_KEY, FB_PIXEL_ID } from './config/constants';

import indexRoutes from "./routes";
import NotFoundPage from "./views/NotFoundPage/NotFoundPage";

import "./assets/scss/material-kit-pro-react.css?v=1.1.0";
//import registerServiceWorker from './registerServiceWorker';

let hist = createBrowserHistory();

hist.listen(location => {
    ReactGA.initialize(GOOGLE_ANALYTICS_KEY);
    ReactGA.pageview(location.pathname);
    ReactGA.ga('config', GOOGLE_ADWORDS_KEY);
});
const fbPixelOptions = { autoConfig: true, debug: false };
ReactPixel.init(FB_PIXEL_ID, null, fbPixelOptions);
ReactPixel.pageView();

if (localStorage.jwtToken) {
    setAuthToken(localStorage.jwtToken);
    const decoded = jwt_decode(localStorage.jwtToken);
    store.dispatch(setCurrentUser(decoded));

    /**
     * TODO: Revisar si el tiempo de expiración llega en el atributo exp
     */
    const currentTime = Date.now()/1000;
    if (decoded.exp < currentTime) {
        store.dispatch(logoutUser());
        window.location.href = '/login';
    }
}

ReactDOM.render(
    <Provider store={store}>
        <Router history={hist}>
            <Switch>
                {indexRoutes.map((prop, key) => {
                    if (prop.private) {
                        return <PrivateRoute exact path={prop.path} key={key} component={prop.component} />
                    } else {
                        return <Route exact path={prop.path} key={key} component={prop.component} />;
                    }
                })}
                <Redirect from='/redireccionar' to='/' />
                <Route component={NotFoundPage} />
            </Switch>
        </Router>
    </Provider>,
    document.getElementById("root")
);

//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js